module.exports = __webpack_public_path__ + "static/img/logo.be16ad1a.png";